import React from 'react'
import { Router } from '@reach/router'

import WeHaveMoved from '../../features/customers/WeHaveMoved';

const CustomerAppRoutes = () => {
    return (
        <Router>
            <WeHaveMoved default />
        </Router>
    );
}

export default CustomerAppRoutes;